import PolicyLabeledContent from "./PolicyLabeledContent";

export default PolicyLabeledContent;
